import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mail-content',
  templateUrl: './mail-content.component.html',
  styleUrls: ['./mail-content.component.css']
})
export class MailContentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    console.log('MailContentComponent');
  }

}
